<template>
  <div class="page-facility">
    <tabbed-view :tabs="getTabs()"/>
  </div>
</template>

<script>
import TabbedView from '@/views/components/tabs/TabbedView';
import {mapGetters} from 'vuex';

export default {
  name: 'Facility',
  components: { TabbedView },
  computed: {
    ...mapGetters({
      isDeleted: 'getIsDeleted'
    })
  },
  mounted() {
    this.setTitle(this.$route.params.id);
  },
  methods: {
    async setTitle(id) {
      const { data } = await this.$api.facilities.get(id);
      if (data.data) {
        await this.$store.dispatch('updatePageTitle', `Facility: ${data.data.FacilityReference}`);
      }
    },
    getTabs() {
      return [
        {
          label: 'Facility Details',
          route: 'facilities.view'
        },
        {
          label: 'Sections',
          route: 'facilities.sections.list',
          hideIfDeleted: this.isDeleted,
        },
        {
          label: 'Markets',
          route: 'facilities.markets.list',
          hideIfDeleted: this.isDeleted,
        },
        {
          label: 'FDOs',
          route: 'facilities.fdos.list',
          hideIfDeleted: this.isDeleted,
        },
        {
          label: 'Distribution Lists',
          route: 'facilities.distribution-lists.list',
          hideIfDeleted: this.isDeleted,
        },
        {
          label: 'Change Logs',
          route: 'facilities.change-logs.list',
          hideIfDeleted: this.isDeleted,
        },
      ]
    }
  },
  watch: {
    $route: {
      handler: async function(to, from) {
        const toId = to.params.id;
        const fromId = from.params.id;
        if (toId != fromId) {
          this.setTitle(toId);
        }
      }
    },
  }
};
</script>

<style>
.page-facility .con-slot-tabs {
  min-height: 40vh;
}
</style>
